import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import FullPageLoader from '~components/FullPageLoader';

import { getSettings } from '~main/actions/login';

import { selectAuthenticated, selectUserTags } from '~main/selectors/login';

const PrivateRoute: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const tponeSessionKey = searchParams.get('tp1-session');
  const isAuthenticated = useAppSelector(selectAuthenticated);
  const tags = useAppSelector(selectUserTags);
  const dispatch = useAppDispatch();

  const tagsLoading = !tags || tags.length === 0;
  const showOutlet = isAuthenticated && !tponeSessionKey && !tagsLoading;

  useEffect(() => {
    // If tp1-session key, redirect to check session via component
    if (tponeSessionKey) {
      searchParams.delete('tp1-session');
      const searchParamString = searchParams.toString();
      const fromUrl = location.pathname + (searchParamString ? `?${searchParamString}` : '');
      navigate('/auth-session', {
        state: { from: fromUrl, sessionKey: tponeSessionKey },
      });
    } else {
      dispatch(getSettings());
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated && !tponeSessionKey) {
      navigate('/login', { state: { from: location.pathname } });
    }
  }, [isAuthenticated]);

  return (
    <>
      <FullPageLoader isLoading={tagsLoading} />
      {showOutlet && <Outlet />}
    </>
  );
};

export default PrivateRoute;
